module.exports = __webpack_public_path__ + "img/alert.6e6cc738.svg";